import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import WhatsappIcon from "assets/images/chatIcons/icon-whatsapp.png";
import getConfig from "config/config";

function Whatsapp() {
  const { language } = useParams();
  const config = getConfig();
  const whatsappLink = config.whatsappUrl;

  const [currentLanguage, setCurrentLanguage] = useState(
    language || sessionStorage.getItem("I18N_LANGUAGE") || "en-US",
  );

  const isVisibleLanguage =
    currentLanguage === "en-US" || currentLanguage === "HI";

  useEffect(() => {
    const checkLanguageUpdate = () => {
      const storedLanguage = sessionStorage.getItem("I18N_LANGUAGE");
      setCurrentLanguage(language || storedLanguage || "en-US");
    };

    const intervalId = setInterval(checkLanguageUpdate, 500);

    return () => clearInterval(intervalId);
  }, [language]);

  useEffect(() => {
    if (whatsappLink && isVisibleLanguage) {
      const whatsappButton = document.createElement("div");
      whatsappButton.id = "whatsapp-widget";
      whatsappButton.style.position = "fixed";
      whatsappButton.style.bottom = "-100px";
      whatsappButton.style.right = "20px";
      whatsappButton.style.zIndex = "1000";
      whatsappButton.style.cursor = "pointer";
      whatsappButton.style.transition = "bottom 0.5s ease";

      // Create an image element for the WhatsApp button
      const whatsappIcon = document.createElement("img");
      whatsappIcon.src = WhatsappIcon;
      whatsappIcon.alt = "Whatsapp Messenger";
      whatsappIcon.style.width = "60px";
      whatsappIcon.style.height = "60px";

      // Append the icon to the button container
      whatsappButton.appendChild(whatsappIcon);

      // Add click event to open WhatsApp Messenger URL in a new tab
      whatsappButton.addEventListener("click", () => {
        window.open(`https://wa.me/${whatsappLink}`, "_blank");
      });

      document.body.appendChild(whatsappButton);

      // Animate the button to appear
      setTimeout(() => {
        whatsappButton.style.bottom = "100px";
      }, 1000);

      return () => {
        const existingButton = document.getElementById("whatsapp-widget");
        if (existingButton) {
          document.body.removeChild(existingButton);
        }
      };
    }
  }, [whatsappLink, isVisibleLanguage]);

  if (!isVisibleLanguage) {
    return null;
  }

  return null;
}

export default React.memo(Whatsapp);
